import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'CourtSearchCompact';

class CourtSearchCompact extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}

	init() {
		const smallSearch = SelectorEngine.findOne('.lta-court-search-compact__small', this._wrapper);
		const largeSearch = SelectorEngine.findOne('.lta-court-search-compact__large', this._wrapper);

		EventHandler.on(this._element, 'click', () => {
			if (smallSearch && largeSearch) {
				smallSearch.classList.add('u-hidden');
				largeSearch.classList.add('u-block');
				this.tabs = this._element.querySelector(':not(.lta-tabs) .lta-tablist').querySelectorAll('.lta-tablist__tab');
				for (const tab of this.tabs) {
					if (this.tabs[0] !== tab && tab.classList.contains('active')) {
						tab.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
					}
				}
			}
		});
	}

	static get NAME() {
		return NAME;
	}
}

export default CourtSearchCompact;
